import { Component, ElementRef, EventEmitter, Inject, Input, Output, ViewChild , HostListener } from '@angular/core';
import { INav } from "bi-interfaces/lib/interfaces/inav";
import { ILayoutSaver } from "bi-interfaces/lib/interfaces/IlayoutSaver";
import { IGrid } from 'bi-interfaces/lib/interfaces/IGrid';
import { LoggerService } from '../../services/logger.service';
import { BIModulesService } from '../../bi-modules.service';
import { INavBtn } from 'bi-interfaces/lib/interfaces/inav-btn';
import { RecordSourceEnum } from 'bi-interfaces';
import { objectHelper } from '../Helper/objectHelper';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { CreateDialog } from '../bi-dialog/createDialog.service';
import { BiAttachmentsComponent } from '../bi-attachments/bi-attachments.component';
import { FormControl } from '@angular/forms';
import { IControls } from 'bi-interfaces';
import { ColViewService } from './col-view.service';
import { ActivatedRoute } from '@angular/router';
import { UiProfileService } from '../../services/ui-profile.service';



@Component({
  selector: 'BI-Nav',
  templateUrl: 'bi-nav.component.html',
  styleUrls: ['bi-nav.component.scss']
})
export class BiNavComponent implements INav, ILayoutSaver {
  [x: string]: any;
  @Input() BIGrid!: IGrid;
  @Input() DomID!: string;
  @Input() PageTitle: string = '';
  @Input() RowTitle: string = '';
  @Input() CanInsert!: boolean;
  @Input() CanUpdate!: boolean;
  @Input() CanDelete!: boolean;
  @Input() CanViewAttachments!: boolean;
  @Input() CanAddAttachments!: boolean;
  @Input() CanDeleteAttachments!: boolean;
  @Input() navButtons: INavBtn = {};
  @Input() deleteConfirmMsg: boolean = false;
  @Output() OnPrint = new EventEmitter<any>();
  @Output() ActionClicked = new EventEmitter<any>();

  opened: boolean = false;
  @ViewChild('addBtn', { static: true }) addBtn: ElementRef | any;
  @ViewChild('saveBtn', { static: true }) saveBtn: ElementRef | any;
  @ViewChild('cancelBtn', { static: true }) cancelBtn: ElementRef | any;
  @ViewChild('deleteBtn', { static: true }) deleteBtn: ElementRef | any;
  @ViewChild('attachBtn', { static: true }) attachBtn: ElementRef | any;
  @ViewChild('infoBtn', { static: true }) infoBtn: ElementRef | any;
  RecordSource: any;
  RecordSourceEnum = RecordSourceEnum;
  CreatedBy: string = "";
  CreatedOn: Date = new Date();
  ModifiedBy: string = "";
  ModifiedOn: Date = new Date();
  BUID: string = "";
  CurrentSelectedLayout: number | null = null;
  AttachmentDialog = this._dialog() as CreateDialog;
  ViewList = [
    { text: this.translateService.instant("one-column"), code: 1 },
    { text: this.translateService.instant("two-column"), code: 2 },
    { text: this.translateService.instant("three-column"), code: 3 },
    { text: this.translateService.instant("four-column"), code: 4 },
  ]

  public ViewControl: FormControl
  ViewControlI: IControls = {
    DomID: '', Name: '', DisplayName: '', colNumber: 0, rowNumber: 0
  }
  //Bi-scrollableNav
  scrollContainer: any;
  scrollLeftArrow: any;
  scrollRightArrow: any;
  scrollPosition: number = 0;


  constructor(
    public loggerService: LoggerService,
    public biService: BIModulesService,
    public elementRef: ElementRef,
    public translateService: TranslateService,
    @Inject('CreateDialog') public _dialog: any,
    public ColViewService: ColViewService,
    private router: ActivatedRoute,
    private uiProfileService: UiProfileService
  ) {
    this.ViewControl = new FormControl('ViewControl');
  }
  //DomID: string | undefined;
ngOnInit(){
  this.scrollContainer = document.querySelector('.holder');
    this.scrollLeftArrow = document.querySelector('.scroll-left');
    this.scrollRightArrow = document.querySelector('.scroll-right');
  this.updateArrows();
}

updateArrows() {
  const screenWidth = window.innerWidth;
  const contentOverflow =
    this.scrollContainer.scrollWidth > this.scrollContainer.clientWidth;
  const displayArrows =
    contentOverflow || ((screenWidth <= 786) && contentOverflow);
  this.scrollLeftArrow.style.display =
    displayArrows && this.scrollPosition > 0 ? "block" : "none";
  this.scrollRightArrow.style.display = displayArrows ? "block" : "none";
}

scrollLeft() {
  this.scrollPosition -= 150;
    this.scrollContainer.scrollTo({ left: this.scrollPosition, behavior: "smooth" });
    this.updateArrows();
}

scrollRight() {
  this.scrollPosition += 150;
    this.scrollContainer.scrollTo({ left: this.scrollPosition, behavior: "smooth" });
    this.updateArrows();
}

@HostListener('window:resize', ['$event'])
  onResize() {
    this.updateArrows();
  }
  checkBordersStyle(element: any) {
    let borders: boolean = false;
    if (this.elementRef.nativeElement.contains(element.nativeElement)) {
      borders = true;
    }
    return borders
  }
  /**
   * add new row to the grid
   * @return void
   */
  AddRow(): void {
    this.ActionClicked.emit({ action: 'add' });
    this.BIGrid?.AddRow();
  };
  /**
   * delete row from the grid
   * @return void
   */
  DeleteRow(): void {
    this.ActionClicked.emit({ action: 'delete' });
    if (this.deleteConfirmMsg) {
      Swal.fire({
        title: this.translateService.instant("ConfirmDelete"),
        icon: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        buttonsStyling: false,
        customClass: {
          cancelButton: 'cancelSweatAlert',
          confirmButton: "confirmSweatAlert",
          title: "titleSweatAlert",
          icon: "iconSweatAlert"
        },
        width: 400,
        focusConfirm: false,
        confirmButtonText: this.translateService.instant("yes"),
        cancelButtonText: this.translateService.instant("Cancel"),
      }).then(res => {
        if (res.isConfirmed) {
          this.BIGrid?.DeleteRow();

        }
      })
    }
    else
      this.BIGrid?.DeleteRow();

  };
  /**
   * save edits in any cell
   * @return void
   */
  Cancel(): void {
    this.ActionClicked.emit({ action: 'cancel' });
    this.BIGrid?.Cancel();
  };
  /**
   * save edits in any cell
   * @return void
   */
  Save(): void {
    this.ActionClicked.emit({ action: 'save' });
    if (this.BIGrid?.CheckPendingChange()) {
      this.BIGrid.Save();
    }
  };
  /**
* attachment in any cell
* @return void
*/
  Attachment(): void {
    if (this.BIGrid.GetValueOf(this.BIGrid.DataService.Key)) {
      this.AttachmentDialog.ShowDialog(BiAttachmentsComponent,
        {
          BIGrid: this.BIGrid,
          CanViewAttachments: this.CanViewAttachments,
          CanAddAttachments: this.CanAddAttachments,
          CanDeleteAttachments: this.CanDeleteAttachments,
        },
        this.translateService.instant('Attachments'), null, this.translateService.instant('Cancel'), true, false);
    }
    else {
      this.loggerService.Content = this.translateService.instant('SelectRowToAttach');
      this.loggerService.Type = 1;
      this.loggerService.Show();
    }
  }
  /**
  * info in any cell
  * @return void
  */
  Info(): void {

    const recordSourceValue = objectHelper.getCaseInsensitiveKeyValue(this.BIGrid.CurrentSelectRow.getRawValue(), 'RecordSource');  //this.BIGrid.CurrentSelectRow.getRawValue()['RecordSource'];
    const salesManSourceValue = objectHelper.getCaseInsensitiveKeyValue(this.BIGrid.CurrentSelectRow.getRawValue(), 'HH_Salesman.RecordSource');//this.BIGrid.CurrentSelectRow.getRawValue()['HH_Salesman.RecordSource'];
    const SourceValue = objectHelper.getCaseInsensitiveKeyValue(this.BIGrid.CurrentSelectRow.getRawValue(), 'Source');//this.BIGrid.CurrentSelectRow.getRawValue()['Source'];

    if (this.BIGrid.CurrentSelectRow.getRawValue()[this.BIGrid.DataService.Key] !== null &&
        this.BIGrid.CurrentSelectRow.getRawValue()[this.BIGrid.DataService.Key] !== undefined)
      this.opened = true;
    else {
      this.loggerService.Content = this.translateService.instant('PleaseSelectRowToGetInformation');
      this.loggerService.Type = 1;
      this.loggerService.Show();
    }
    this.RecordSource = recordSourceValue ?? salesManSourceValue ?? SourceValue;
    this.CreatedBy = objectHelper.getCaseInsensitiveKeyValue(this.BIGrid.CurrentSelectRow.getRawValue(), 'Createdby');
    this.CreatedOn = objectHelper.getCaseInsensitiveKeyValue(this.BIGrid.CurrentSelectRow.getRawValue(), 'CreatedOn');
    this.ModifiedBy = objectHelper.getCaseInsensitiveKeyValue(this.BIGrid.CurrentSelectRow.getRawValue(), 'ModifiedBy');
    this.ModifiedOn = objectHelper.getCaseInsensitiveKeyValue(this.BIGrid.CurrentSelectRow.getRawValue(), 'ModifiedOn');
    this.BUID = objectHelper.getCaseInsensitiveKeyValue(this.BIGrid.CurrentSelectRow.getRawValue(), 'buid');

    /* if(this.BIGrid.CurrentSelectRow.getRawValue().hasOwnProperty('RecordSource')) {
       this.RecordSource = recordSourceValue
     } else if(this.BIGrid.CurrentSelectRow.getRawValue().hasOwnProperty('HH_Salesman.RecordSource')) {
       this.RecordSource = salesManSourceValue
     } else if (this.BIGrid.CurrentSelectRow.getRawValue().hasOwnProperty('Source')) {
       this.RecordSource = SourceValue
     }   */
  };

  /**
    * close info popup
    * @return void
  */
  Close(): void {
    this.opened = false;
  }
  Print() {
    this.OnPrint.emit(null);
  }

  GetErpawarePermission(): boolean {
    let erpawareCheck = JSON.parse(localStorage.getItem('erpawarePermission') || 'null');
    return (erpawareCheck ? erpawareCheck.permission : true);
  }
  OnViewselectionChanges(number:number): void {
    this.CurrentSelectedLayout = number;
    this.ColViewService.ColNumber.next(number)
  }
  SaveLayoutForScreenClicked(){
    this.uiProfileService.emitSaveColumnLayout(this.CurrentSelectedLayout)
  }
}
